// src/components/InteractionDetailsModal.jsx
import React from 'react';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
} from '@/components/ui/dialog';
import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';

const InteractionDetailsModal = ({
    isOpen,
    onClose,
    interaction,
    formatTimestamp,
    markAsRead,
    markAsReplied,
}) => {
    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent className="max-w-2xl" style={{ zIndex: 1000 }}>
                <DialogHeader>
                    <DialogTitle>Interaction Details</DialogTitle>
                    <DialogDescription>
                        Full details of the contact interaction
                    </DialogDescription>
                </DialogHeader>

                {interaction && (
                    <div className="space-y-4">
                        <Card className="p-4">
                            <div className="grid grid-cols-2 gap-4 text-sm">
                                <div>
                                    <span className="font-medium">Contact:</span> {interaction.name || interaction.contactName}
                                </div>
                                <div>
                                    <span className="font-medium">Organization:</span> {interaction.organizationName}
                                </div>
                                <div>
                                    <span className="font-medium">Status:</span>
                                    <Badge variant="default" className="ml-2">{interaction.status}</Badge>
                                </div>
                                <div className="col-span-2">
                                    <span className="font-medium">Timestamp:</span>{' '}
                                    {formatTimestamp(
                                        interaction.lastReplyAt ||
                                        interaction.timestamp ||
                                        interaction.lastInteraction
                                    )}
                                </div>
                            </div>
                        </Card>

                        <Card className="p-4">
                            <h4 className="font-medium mb-2">Content</h4>
                            <div className="bg-muted p-3 rounded text-sm whitespace-pre-wrap">
                                {interaction.lastReplyText || interaction.content || '—'}
                            </div>
                        </Card>

                        <div className="flex justify-end space-x-2">
                            {!interaction.read && (
                                <Button variant="outline" onClick={() => markAsRead(interaction.id)}>
                                    Mark as Read
                                </Button>
                            )}
                            {!interaction.replied && interaction.type === 'reply' && (
                                <Button onClick={() => markAsReplied(interaction.id)}>
                                    Mark as Replied
                                </Button>
                            )}
                        </div>
                    </div>
                )}
            </DialogContent>
        </Dialog>
    );
};

export default InteractionDetailsModal;